<template>
  <div>
    <div v-if="cvUrl" class="radish-page-left">
      <iframe
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        allowtransparency="yes"
        :src="cvUrl"
      ></iframe>
    </div>
    <div v-loading="loading" class="radish-page-right">
      <div class="radish-head">
        <div class="radish-title">新建人才</div>
        <div class="radish-btns">
          <div v-show="isSaveShow" class="radish-btn radish-btn-primary" @click="save">保存</div>
        </div>
      </div>
      <div v-if="ready" class="radish-body">
        <div class="radish-box">
          <div class="radish-box-content">
            <formItem
              :type="fieldAttach.type"
              :is-inline="true"
              :width="fieldAttach.width"
              :label="fieldAttach.label"
              :options="fieldAttach.options"
              :content="'原始简历'"
              :handle-data-change="handleAttachTypeChange"
            />
            <el-button size="mini" round @click="showUpload">上传</el-button>
            <div v-if="attachData[attachType] && attachData[attachType].length > 0">
              <div v-for="(attach, k) in attachData[attachType]" :key="k">
                <b>{{ attach.originalname }}</b>
              </div>
            </div>
            <formItem
              :type="fieldPro.type"
              :is-inline="true"
              :label="fieldPro.label"
              :options="fieldPro.options"
              :content="pid"
              :handle-data-change="handleProChange"
            />
          </div>
        </div>
        <div v-for="(box, k) in fieldsAll" :key="k" class="radish-box">
          <div class="radish-box-title">{{ box.title }}</div>
          <div class="radish-box-content">
            <template v-for="(f, fk) in box.fields">
              <formItem
                :key="fk"
                :type="f.type"
                :is-inline="true"
                :is-required="f.isRequired"
                :width="f.width"
                :label="f.label"
                :placeholder="f.placeholder"
                :options="f.options"
                :content="formData[f.label]"
                :handle-data-change="handleItemChange"
                :handle-blur="handleBlur"
              />
              <div v-if="f.label === '手机' && dupData.id" :key="fk + 'd'" class="radish-dup">
                <i class="el-icon-warning">候选人已存在:</i>&nbsp;
                <span class="radish-link" @click="showRadish({ id: dupData.id, name: dupData['姓名'] })">{{
                  dupData['姓名']
                }}</span>
                <span>{{ (dupData['公司'] || '-') + ' ' + (dupData['部门'] || '-') }}</span> &nbsp;&nbsp;
                <el-button
                  v-if="currentParse.fileId"
                  style="margin-left:20px;"
                  type="primary"
                  plain
                  size="mini"
                  @click="mergeOne('o')"
                  >保存为附件</el-button
                >
                <el-button size="mini" type="primary" plain @click="mergeOne('n')">代替原数据</el-button>
              </div>
            </template>
          </div>
        </div>
        <div v-for="(box, k) in fieldsExp" :key="k" class="radish-box">
          <div class="radish-box-title">{{ box.title }}</div>
          <div class="radish-box-addbtn" @click="addExp(k)">+</div>
          <div v-for="(c, key) in formExpData[k]" :key="key" class="radish-box-content">
            <div class="radish-box-delbtn" @click="delExp(k, key)">-</div>
            <template v-for="(f, fk) in box.fields">
              <formItem
                :key="fk"
                :type="f.type"
                :is-inline="true"
                :is-required="f.isRequired"
                :width="f.width"
                :label="f.label"
                :box="k"
                :index="key"
                :options="f.options"
                :content="c[f.label]"
                :handle-data-change="handleExpChange"
              />
            </template>
          </div>
        </div>
      </div>
      <UploadDialog
        ref="UploadDialog"
        :type="uploadType"
        :label="attachType"
        :on-success="uploadSuccess"
      ></UploadDialog>
    </div>
  </div>
</template>
<script>
import { constants } from 'fs'
import { UploadDialog } from '../../file'
import { fieldsAll, fieldsExp } from './constant/fields-add'
import { phoneVali } from './constant/common-methods'

export default {
  components: { UploadDialog },
  data: function() {
    return {
      ready: false,
      loading: true,
      isSaveShow: true,
      catData: [],
      fieldsAll: fieldsAll,
      fieldsExp: fieldsExp,
      fieldAttach: {
        label: '上传附件',
        type: 'select',
        width: '50%',
        options: ['原始简历', '推荐报告', '背景调查', '薪资证明', '测评报告', '其他资料'],
      },
      fieldPro: {
        label: '加入项目',
        type: 'select',
        options: [],
      },
      formData: {
        地域: [],
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        期望行业: [],
        期望地域: [],
        学历标签: [],
        语言标签: [],
        职业资格: [],
      },
      formExpData: {
        教育: [{}],
        工作: [{}],
        项目: [{}],
      },
      attachType: '',
      uploadType: '原始简历',
      attachData: {
        原始简历: [],
        推荐报告: [],
        背景调查: [],
        薪资证明: [],
        测评报告: [],
        其他资料: [],
      },
      dupData: {},
      currentParse: {},
      pid: '',
      requiredFields: ['姓名'],
      cvUrl: '',
      isLinkedin: false,
    }
  },
  created: function() {
    Promise.all([this.loadPro(), this.loadCate()]).then(() => {
      // 初始化人选添加页面信息
      window.initRadish = async (data, expData, url, html, liepinPhoneStr, liepinEmailStr) => {
        console.log(url, liepinPhoneStr, liepinEmailStr)
        const isLinkedin = url.indexOf('linkedin.com') !== -1
        this.isLinkedin = isLinkedin
        // eslint-disable-next-line no-restricted-syntax
        for (const field in data) {
          if (data[field]) {
            if (data[field] instanceof Array) {
              data[field] = data[field].filter(dt => !!dt)
            }
            this.formData[field] = data[field]
          }
        }
        this.formData.长期意向 = 'Y'
        this.formExpData = expData
        if (!isLinkedin) {
          this.cvUrl = url
        }
        console.log(1)
        if (liepinPhoneStr) {
          const phoneRes = await app.service('radish').parseImgStrV2({ base64img: liepinPhoneStr })
          if (phoneRes.status === 'success') {
            const phoneNumber = phoneRes.data
            if (phoneNumber && phoneNumber.indexOf('转') < 0) {
              this.formData['手机'] = phoneNumber
            }
          }
          console.log(2)
          console.log('phone', JSON.stringify(phoneRes))
        }
        if (liepinEmailStr) {
          const emailRes = await app.service('radish').parseImgStrV2({ base64img: liepinEmailStr })
          if (emailRes.status === 'success') {
            let email = emailRes.data
            if (email.endsWith('@qqc。m')) {
              email = email.replace('@qqc。m', '@qq.com')
            }
            this.formData['邮箱'] = email
          }
          console.log(3)
          console.log('email', JSON.stringify(emailRes))
        }
        const file = await app.service('radish').saveHtml({
          html: html,
          data,
          expData,
          filename: `${data['姓名'] || '未命名'}from插件.html`,
        })
        console.log(4)
        console.log(file)
        if (file.status === 'success') {
          const dt = {
            fileId: file.data._id,
            uploader: file.data.uploader || file.data.account,
            originalname: file.data.originalname,
            src: file.data.src,
            md5: file.data.md5,
          }
          this.attachData['原始简历'].push(dt)
          this.currentParse = dt
          this.ready = true
          this.loading = false
          if (isLinkedin) {
            this.preview(file.data)
          }
        }
      }
    })
  },
  methods: {
    handleBlur: async function(res) {
      let { label, content } = res
      if (label === '手机') {
        if (content) {
          content = content.replace(/[^0-9]/g, '').replace(/^86(.*?)/, '$1')
          if (phoneVali(content)) {
            const isDup = await this.duplicate(content)
            if (isDup) {
              return false
            }
          } else {
            this.$message.info('手机格式错误')
            this.dupData = {}
            return false
          }
        } else {
          this.dupData = {}
          this.isSaveShow = true
        }
      }
      return true
    },
    handleItemChange: function(res) {
      const { label, content } = res
      if (label === '职能模块') {
        this.ready = false
        const currentCat = this.catData.filter(cat => content.includes(cat['名称']))
        if (currentCat.length > 0) {
          let znArr = []
          let scArr = []
          currentCat.forEach(cat => {
            if (cat['二级职能'] && cat['二级职能'].length > 0) {
              znArr = znArr.concat(cat['二级职能'])
            }
            if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
              scArr = scArr.concat(cat['擅长方向'])
            }
          })
          this.fieldsAll['基本信息'].fields['细分职能'].options = this.unique(znArr)
          this.fieldsAll['基本信息'].fields['擅长方向'].options = this.unique(scArr)
          this.fieldsAll['基本信息'].fields['专业职级'].options = content && content.includes('HH-猎头') ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO'] : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        }
        this.ready = true
      } else if (label === '从业起始年') {
        this.formData[label] = parseInt(content)
      }
      this.formData[label] = content
    },
    handleExpChange: function(res) {
      const { label, content, box, index } = res
      this.formExpData[box][index][label] = content
    },
    handleProChange: function(res) {
      const { content } = res
      this.pid = content
    },
    handleAttachTypeChange: function(res) {
      const { content } = res
      this.attachType = content
      if (content === '原始简历') {
        this.uploadType = '原始简历'
      } else if (content === '推荐报告') {
        this.uploadType = '推荐报告'
      } else if (content == '会面记录') {
        this.uploadType = '会面记录'
      } else {
        this.uploadType = '附件'
      }
    },
    duplicate: async function(phone) {
      console.log(phone)
      const dup = await app.service('radish').duplicate({ phone: phone })
      if (dup.msg === 'duplicate') {
        this.dupData = dup.data
        this.isSaveShow = false
        return true
      } else {
        this.dupData = {}
        this.isSaveShow = true
        return false
      }
    },
    save: async function() {
      const dt = JSON.parse(JSON.stringify(this.formData))
      const edt = JSON.parse(JSON.stringify(this.formExpData))
      const vali = await this.fieldValidate(dt, edt)
      if (!vali) {
        return false
      }
      if (dt['手机']) {
        const ok = await this.handleBlur({
          label: '手机',
          content: dt['手机'],
        })
        if (!ok) {
          return false
        }
      }
      dt['姓名'] = dt['姓名'] ? dt['姓名'].replace(' ', '') : ''
      this.loading = true
      const result = await this.saveForm(dt)
      console.log('basic', result)
      if (result.status === 'success') {
        const rid = result.data.id
        const aRes = await this.saveAttach(rid)
        const eRes = await this.saveExp(edt, rid)
        if (this.formData['客户资源'] && this.formData['客户资源'].length > 0) {
          app.user.kehuziyuanOpt = Array.from(new Set((app.user.kehuziyuanOpt || []).concat(this.formData['客户资源'] || [])))
          await app.service('users').patch(app.user._id, {
            kehuziyuanOpt: app.user.kehuziyuanOpt,
          })
        }
        console.log('a', aRes)
        console.log('e', eRes)
        if (this.pid) {
          const pRes = await this.intoPro(rid)
          if (pRes.status === 'success') {
            this.$message.success({
              duration: 500,
              message: '成功添加并加入项目',
            })
          } else {
            this.$message.error(`intopro error:${pRes.msg}`)
          }
        } else {
          this.$message.success({ duration: 500, message: '添加成功' })
        }
        router.push(`/radish-detail-blank/${rid}`)
      } else {
        this.$message.error(`save error:${result.msg}`)
      }
      this.loading = false
    },
    fieldValidate: function(dt, edt) {
      const empty = []
      this.requiredFields.forEach(f => {
        if (f instanceof Object) {
          for (const key in f) {
            const farr = f[key]
            farr.forEach(f2 => {
              if (!edt[key][0][f2]) {
                empty.push(f2)
              }
            })
          }
        } else if (!dt[f]) {
          empty.push(f)
        }
      })
      if (empty.length > 0) {
        this.$message.info(`请填写${empty.join('、')}`)
        return false
      }
      return true
    },
    saveForm: async function(dt) {
      dt.from = 'addPage'
      if (this.isLinkedin && (dt.邮箱 || dt.微信)) {
        const query = {}
        // if (dt.手机) {
        //   query.手机 = dt.手机
        // }
        if (dt.邮箱) {
          query.邮箱 = dt.邮箱
        }
        if (dt.微信) {
          query.微信 = dt.微信
        }
        if (Object.keys(query).length > 0) {
          try {
            const dupRadishes = await app.service('radish').batchGetRadishes({ query })
            if (dupRadishes && dupRadishes.status == 'success' && dupRadishes.data.total > 0) {
              // this.$message.error(`该领英简历的字段 ${Object.keys(query).join('、')} 与系统中人选重复，请不要重复抓取`)
              return {
                status: 'fail',
                msg: `该领英简历的字段 ${Object.keys(query).join('、')} 与系统中人选重复，请不要重复抓取`,
              }
            }
          } catch (e) {
            console.error(e)
          }
        }
      }
      const result = await app.service('radish').insert(dt)
      await app.service('misc').insertBussinessAssistTask({
        type: '新建人选',
        data: { radishId: result.data.id, 姓名: dt.姓名 },
      })
      return result
    },
    saveAttach: async function(rid) {
      const dt = []
      const adt = JSON.parse(JSON.stringify(this.attachData))
      for (const key in adt) {
        adt[key].forEach(item => {
          const tmp = {
            fileId: item._id,
            uploader: item.uploader || item.account,
            originalname: item.originalname,
            src: item.src,
            md5: item.md5,
            rid: rid,
          }
          dt.push(tmp)
        })
      }
      if (dt.length > 0) {
        const aRes = await app.service('radish').addAttachment(dt)
        return aRes
      } else {
        return { status: 'fail', msg: '未添加附件' }
      }
    },
    saveExp: async function(edt, rid) {
      const dt = []
      for (const key in edt) {
        edt[key].forEach(item => {
          if (Object.keys(item).length > 0) {
            item.rid = rid
            item.type = key
            dt.push(item)
          }
        })
      }
      if (dt.length > 0) {
        const eRes = await app.service('radish').addExperience(dt)
        const comDt = dt.filter(d => d.type === '工作')
        if (comDt.length > 0) {
          await app.service('radish').modifyById({ _id: rid, data: { 任职经历: comDt } })
        }
        return eRes
      } else {
        return { status: 'fail', msg: '未添加经历' }
      }
    },
    intoPro: async function(rid) {
      const pRes = await app.service('radish').intoProject({ pid: this.pid, rid: rid })
      return pRes
    },
    addExp: function(k) {
      this.formExpData[k].unshift({})
    },
    delExp: function(type, index) {
      this.$confirm('确定删除该经历吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.formExpData[type].splice(index, 1)
        })
        .catch(() => {})
    },
    showUpload: function() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    showRadish: function(params) {
      const { id, name } = params
      app.root.$refs.radishLeft.show(id)
    },
    uploadSuccess: function(response, file, fileList) {
      response.forEach(res => {
        const dt = {
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
        }
        this.attachData[this.attachType].push(dt)
      })
      this.$refs.UploadDialog.visible()
    },
    mergeOne: async function(main) {
      if (this.dupData.id && this.currentParse.fileId) {
        this.loading = true
        const rid = this.dupData.id
        const n = JSON.parse(JSON.stringify(this.formData))
        const edt = JSON.parse(JSON.stringify(this.formExpData))
        const attachs = []
        const adt = JSON.parse(JSON.stringify(this.attachData))
        for (const key in adt) {
          adt[key].forEach(item => {
            item.rid = rid
            item.type = key
            attachs.push(item)
          })
        }
        const nExp = []
        for (const key in edt) {
          edt[key].forEach(item => {
            if (Object.keys(item).length > 0) {
              item.rid = rid
              item.type = key
              nExp.push(item)
            }
          })
        }
        const data = [
          {
            o: { _id: this.dupData.id },
            n: n,
            nExp: nExp,
            nAttach: attachs,
          },
        ]
        const res = await app.service('radish').merge({
          data: data,
          main: main,
          from: 'cv',
        })
        if (res.status === 'success') {
          console.log(this.pid)
          if (this.pid) {
            const pRes = await this.intoPro(rid)
            if (pRes.status === 'success') {
              this.$message.success({
                duration: 500,
                message: '合并成功并加入项目成功',
              })
            } else {
              console.log(`intopro error:${pRes.msg}`)
            }
          } else {
            this.$message.success({ duration: 500, message: '合并成功' })
          }
          router.push(`/radish-detail-blank/${this.dupData.id}`)
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      }
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        this.catData = catData
        this.fieldsAll['基本信息'].fields['职能模块'].options = catData.map(item => item['名称'])
      }
    },
    loadPro: async function() {
      if (!app.projects) {
        await app.getProjects()
      }
      const proData = app.projects
      if (proData && proData.length > 0) {
        const opts = {}
        proData.forEach(item => {
          const v = `${item['项目名称']}(${item['客户公司']})`
          opts[item._id] = v
        })
        this.fieldPro.options = opts
      }
    },
    unique: function(arr) {
      return Array.from(new Set(arr))
    },
    reset: function() {
      this.formData = {
        地域: [],
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        期望行业: [],
        期望地域: [],
        学历标签: [],
        语言标签: [],
        职业资格: [],
      }
      this.formExpData = {
        教育: [{}],
        工作: [{}],
        项目: [{}],
      }
      this.attachType = ''
      this.uploadType = '原始简历'
      this.attachData = {
        原始简历: [],
        推荐报告: [],
        背景调查: [],
        薪资证明: [],
        测评报告: [],
        其他资料: [],
      }
      this.dupData = {}
      this.currentParse = {}
    },
    preview: async function(file) {
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
  },
}
</script>
<style>
.radish-page-left {
  position: absolute;
  top: 60px;
  bottom: 0;
  width: 50vw;
  overflow: auto;
}
.radish-page-right {
  position: absolute;
  top: 60px;
  bottom: 0;
  right: 0;
  width: 50vw;
  overflow: auto;
  border-left: 1px solid #e1e1e1;
}
</style>
